<div class="white m-t-md round-content ch-grey">
  <div class="p-a">
    <p class="m-b-0 _700 text-md">
      <span translate>IVR.LABEL</span>
      <ui-switch class="pull-right custom m-t-2px" [checked]="isIvrEnabled" (change)="onIsIvrEnabledChange($event)"></ui-switch>
    </p>
  </div>
  <div *ngIf="isIvrEnabled" class="row no-gutter p-x p-y b-b">
    <label class="col-sm-2 label-h-i grey-text p-b" *ngIf="(ivrs$ | async)?.length">
      {{ 'CHOOSE' | translate }}
    </label>
    <div class="col-sm-10 p-b" *ngIf="(ivrs$ | async)?.length">
      <mat-select
        class="w-45"
        [placeholder]="'IVR.SELECT_IVR' | translate"
        [value]="selectedIvr"
        (selectionChange)="onSelectIvr($event)"
      >
        <mat-option
          *ngFor="let item of ivrs$ | async"
          [value]="item.id"
        >
          {{ item.name }}
        </mat-option>
      </mat-select>
    </div>
    <div class="col-xs-12 text-right p-x light-grey-text">
      <span>
        {{ 'IVR.CANT_FIND_IVR' | translate }}
      </span>
      <a
        class="text-primary pull-right m-l-sm"
        (click)="goToCreateIvr()"
      >
        {{ 'ADD_NEW' | translate }}
      </a>
    </div>
  </div>
</div>
